<template>

    <div class='container'>
        <div class='columns'>

            <div class='column is-3'>
                <div class='has-text-centered'>
                    <center>
                        <figure class="image">
                          <img v-bind:src="university.image" style='height:200px;width:200px;'>
                        </figure>
                    </center>

                    <h1 class='title is-4'>{{university.name}}</h1>
                    <h2 class='subtitle is-5'>"{{university.motto}}"</h2>
                    <nav class="level">
                      <div class="level-item has-text-centered">
                        <div>
                          <p class="heading">Members</p>
                          <p class="title">{{members.length}}</p>
                        </div>
                      </div>
                      <div class="level-item has-text-centered">
                        <div>
                          <p class="heading">Projects</p>
                          <p class="title">{{projects.length}}</p>
                        </div>
                      </div>
                    </nav>

                    <p class='has-text-justified'>{{university.description}}</p>
                </div>
            </div>

            <div class='column is-9'>
                <b-tabs type="is-boxed" v-model="activeTab">

                    <b-tab-item>
                        <template slot="header">
                            <b-icon icon="newspaper"></b-icon>
                            <span>Projects</span>
                        </template>

                        <project-card-list :projects="projects" :key="projects.length"></project-card-list>
                    </b-tab-item>

                    <b-tab-item>
                        <template slot="header">
                            <b-icon icon="bullhorn"></b-icon>
                            <span>News</span>
                        </template>

                        <new-post v-if="isDean" :projects="projects" :universityId="university.id" @create-post="postCreated"></new-post>

                        <post v-for="post in posts"
                            :key="post.id"
                            :post="post"
                            :highlighedProjectImage="post.highlightedProject ? getProjectImage(post.highlightedProject.id) : null">
                        </post>
                    </b-tab-item>

                    <b-tab-item>
                        <template slot="header">
                            <b-icon icon="account-multiple"></b-icon>
                            <span>Members</span>
                        </template>

                        <user-tile
                            v-for="member in members" :key="member.id"
                            :user="member">
                        </user-tile>
                    </b-tab-item>

                    <b-tab-item v-if="isDean">
                        <template slot="header">
                            <b-icon icon="clipboard-check" type="is-primary"></b-icon>
                            <span>Pending Projects</span>
                        </template>

                        <h3 class="title is-5">
                            The following projects are awaiting approval to be displayed
                            under {{university.name}}
                        </h3>
                        <h4 class='subtitle is-6'>Approving will allow anyone to view the project.</h4>
                        <approve-project
                            v-for="project in pendingProjects" :key="project.id"
                            :project="project" :univId="university.id"
                            @project-approved="projectApproved">
                        </approve-project>
                    </b-tab-item>

                </b-tabs>
            </div>

        </div>
    </div>

</template>

<script>
export default {
  name: 'University',
  data () {
    return {
        activeTab: 0,
        university: {
            name: 'University name',
            motto: 'Motto goes here',
            image: 'https://bulma.io/images/placeholders/256x256.png',
            description: 'Description goes here. It will be loaded by an HTTP request.'
        },
        members: [],
        projects: [],
        pendingProjects: [],
        posts: [],
        isDean: false
    }
  },
  mounted: function() {
    this.isDean = this.$root.user.dean && this.$root.user.dean.id != 0;

    this.$http.get(this.$hostname + '/university/' + this.$route.params.universitySlug).then(function(response) {
        this.university = response.body;

        this.$http.get(this.$hostname + '/posts/university/' + this.university.id).then(function(response) {
            this.posts = response.body;
        });

        this.$http.get(this.$hostname + '/university/' + this.university.id + '/members').then(function(response) {
            this.members = response.body;
        });
    });

    this.$http.get(this.$hostname + '/university/' + this.$route.params.universitySlug + '/projects').then(function(response) {
        this.projects = response.body;
    });

    if(this.isDean) {
        this.$http.get(this.$hostname + '/university/' + this.$route.params.universitySlug + '/projects/pending').then(function(response) {
            this.pendingProjects = response.body;
        });
    }
  },
  methods: {
    getProjectImage: function(projectId) {
      return this.projects.find((project) => {
        return project.id === projectId;
      }).image[0].sizes.card;
    },
    postCreated(post) {
      post.university = this.university;
      if(post.highlightedProject) post.highlightedProject = this.projects.find((proj) => {
          return proj.id === post.highlightedProject;
      });
      this.posts.unshift(post); // add post to beginning of array (see: https://stackoverflow.com/a/8073709)
      // this.$set(this.posts, this.posts.length, post);
    },
    projectApproved(project) {
      this.projects.push(project);

      var pendingProjectIndex = this.pendingProjects.findIndex(function(p) {
        return p.id === project.id;
      });
      this.pendingProjects.splice(pendingProjectIndex, 1);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/University.vue